<template>
  <div>
    <travel-service-menu />
    <h2>
      {{ $t("settings.travelService.additionalSettings.availableServiceTypes") }}
    </h2>
    <v-checkbox :label="$t('settings.travelService.additionalSettings.flightInsurance')" v-model="model.travel_service_flight_available" />
    <v-checkbox :label="$t('settings.travelService.additionalSettings.hotelInsurance')" v-model="model.travel_service_hotel_available" />
    <v-checkbox :label="$t('settings.travelService.additionalSettings.railInsurance')" v-model="model.travel_service_rail_available" />
    <v-checkbox :label="$t('settings.travelService.additionalSettings.carInsurance')" v-model="model.travel_service_car_available" />

    <fieldset class="custom-fieldset">
      <legend>{{ $t("settings.travelService.additionalSettings.standardOptionsFlight") }}</legend>
      <v-checkbox :label="$t('travelService.registeredBaggageWillBeAssigned')" v-model="model.registered_baggage_will_be_assigned" />
      <v-checkbox :label="$t('travelService.isReturnRoute')" v-model="model.flight_is_return_route" />
    </fieldset>

    <fieldset class="custom-fieldset">
      <legend>{{ $t("settings.travelService.additionalSettings.standardOptionsHotels") }}</legend>
      <v-checkbox :label="$t('global.breakfast')" v-model="model.is_breakfast_required" />
      <v-checkbox :label="$t('travelService.isParkingRequired')" v-model="model.is_parking_required" />
      <v-checkbox :label="$t('travelService.isFreeCancellationRequired')" v-model="model.is_free_cancellation_required" />
    </fieldset>
    <fieldset class="custom-fieldset">
      <legend>{{ $t("travelService.insurance") }}</legend>
      <v-row>
        <div class="pa-3 insurance-icon"><v-icon x-large color="primary">fa-plane</v-icon></div>
        <div>
          <span class="insurance-label">{{ $t("travelService.forFlights") }}</span>
          <v-radio-group row v-model="model.travel_service_flight_insurance">
            <v-radio :label="insuranceOption.text" :value="insuranceOption.value" v-for="insuranceOption of insuranceOptions" :key="insuranceOption.value" />
          </v-radio-group>
        </div>
      </v-row>
      <v-row>
        <div class="pa-3 insurance-icon"><v-icon x-large color="primary">fa-hotel</v-icon></div>
        <div>
          <span class="insurance-label">{{ $t("travelService.forHotels") }}</span>
          <v-radio-group row v-model="model.travel_service_hotel_insurance">
            <v-radio :label="insuranceOption.text" :value="insuranceOption.value" v-for="insuranceOption of insuranceOptions" :key="insuranceOption.value" />
          </v-radio-group>
        </div>
      </v-row>
      <v-row>
        <div class="pa-3 insurance-icon"><v-icon x-large color="primary">fa-train</v-icon></div>
        <div>
          <span class="insurance-label">{{ $t("travelService.forRails") }}</span>
          <v-radio-group row v-model="model.travel_service_rail_insurance">
            <v-radio :label="insuranceOption.text" :value="insuranceOption.value" v-for="insuranceOption of insuranceOptions" :key="insuranceOption.value" />
          </v-radio-group>
        </div>
      </v-row>
      <v-row>
        <div class="pa-3 insurance-icon"><v-icon x-large color="primary">fa-car</v-icon></div>
        <div>
          <span class="insurance-label">{{ $t("travelService.forCars") }}</span>
          <v-radio-group row v-model="model.travel_service_car_insurance">
            <v-radio :label="insuranceOption.text" :value="insuranceOption.value" v-for="insuranceOption of insuranceOptions" :key="insuranceOption.value" />
          </v-radio-group>
        </div>
      </v-row>
    </fieldset>

    <v-select :label="$t('travelService.changesAcceptanceLabel')" :items="changeAcceptanceOptions" v-model="model.travel_service_offer_changes_behavior" />

    <v-btn class="accent" @click="saveSettings">{{ $t("global.save") }}</v-btn>
  </div>
</template>

<script>
import TravelServiceMenu from "../../../components/Settings/TravelService/TravelServiceMenu";
import { insuranceOptions, changeAcceptanceOptions } from "../../../staticData/TravelServiceTypes";

export default {
  name: "SettingsTravelServiceAdditionalSettingsView",
  components: { TravelServiceMenu },
  data: () => ({
    model: {
      travel_service_flight_insurance: false,
      travel_service_hotel_insurance: false,
      travel_service_rail_insurance: false,
      travel_service_car_insurance: false,
      travel_service_flight_available: true,
      travel_service_hotel_available: true,
      travel_service_rail_available: true,
      travel_service_car_available: true,
      registered_baggage_will_be_assigned: true,
      flight_is_return_route: false,
      is_parking_required: false,
      is_free_cancellation_required: false,
      is_breakfast_required: false,
      travel_service_offer_changes_behavior: null
    }
  }),
  computed: {
    insuranceOptions,
    changeAcceptanceOptions
  },
  methods: {
    downloadSettings() {
      this.axios.get("settings/travel-service/get-additional-settings").then(resp => {
        Object.assign(this.model, resp.data);
      });
    },
    saveSettings() {
      this.axios.post("settings/travel-service/save-additional-settings", this.model).then(() => {
        this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        });
      });
    }
  },
  created() {
    this.downloadSettings();
  }
};
</script>

<style scoped>
.insurance-icon {
  width: 85px;
  text-align: center;
}
.insurance-label {
  font-weight: 700;
  text-transform: uppercase;
  color: #909194;
  font-size: larger;
}
</style>
